export default "__VITE_ASSET__DNA8NMpB__"